import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from '@gatsbyjs/reach-router';
import { useLazyQuery, useApolloClient } from '@apollo/client';
import Results from '../../components/Results';
import AirLoader from '../../components/AirLoader';
import { RETRIEVE_BOOKING, IS_LOGGED_IN } from '../../operations/queries';
import { setBookingToken } from '../../operations/localState/setBookingProfile';
import { bookingProfileVar } from '../../operations/localState/reactiveVariables';
import InternalError from '../../components/InternalError';
import {
  FLIGHT_SEARCH_TYPE,
  SESSION_STORAGE_LAST_DEPARTURE_FLIGHT_RESULTS,
  SESSION_STORAGE_BOOKING_TOKEN_NAME,
} from '../../utils/constants';
import Dictionary from '../../utils/dictionary';
import useDictionary from '../../hooks/useDictionary';
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from '../../operations/sessionStorage/utils';
import setSearchResults from '../../operations/localState/setSearchResults';

const ResultsDeparture = () => {
  const getDictionary = useDictionary(Dictionary);
  const client = useApolloClient();
  const tokenVar = bookingProfileVar()?.bookingToken;

  const lastDepartureFlightResults = getSessionStorageItem(
    SESSION_STORAGE_LAST_DEPARTURE_FLIGHT_RESULTS,
  );

  const [
    executeRetrieveBooking,
    { loading: retrieveBookingLoading, data: retrieveBookData, error: retrieveBookError },
  ] = useLazyQuery(RETRIEVE_BOOKING, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  });

  const location = useLocation();
  const searchParams = new URLSearchParams(location?.search);

  const bookingId = searchParams.get('bookingId');
  const shipCode = searchParams.get('shipCode');
  const sailDate = searchParams.get('date');
  const lastName = searchParams.get('lastName');
  const urlToken = searchParams.get('token');

  useEffect(() => {
    if (bookingId && shipCode && sailDate && lastName) {
      executeRetrieveBooking({
        variables: {
          bookingId,
          lastName,
          sailDate,
          shipCode,
        },
      });
    }
  }, []);

  const saveBookingToken = (token) => {
    if (token) {
      setSessionStorageItem(SESSION_STORAGE_BOOKING_TOKEN_NAME, token);
      setBookingToken(token);
      client.writeQuery({ query: IS_LOGGED_IN, data: { isLoggedIn: true } });
    }
  };

  useEffect(() => {
    if (retrieveBookData) {
      const { token } = retrieveBookData?.retrieveBooking || '';
      if (token) {
        saveBookingToken(token);
      }
    }
  }, [retrieveBookData]);

  useEffect(() => {
    if (lastDepartureFlightResults?.matchingFlights) {
      setSearchResults(lastDepartureFlightResults);
    }
  }, [lastDepartureFlightResults]);

  useEffect(() => {
    document.querySelector('.main-container').scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (document.getElementsByClassName('route-search')[0]) {
      document.getElementsByClassName('route-search')[0].className = 'route';
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>{getDictionary(Dictionary.airResultsDepartureSeoTitle.key)}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <AirLoader
        open={retrieveBookingLoading}
        status={getDictionary(Dictionary.loaderRetrieveCruise.key)}
      />
      {retrieveBookError && <InternalError />}
      {(tokenVar || urlToken || !retrieveBookingLoading) && (
        <Results flightType={FLIGHT_SEARCH_TYPE.DEPARTURE} />
      )}
      ;
    </>
  );
};

export default ResultsDeparture;
